import { setDownloadFileStatus } from "actions/file";
import { put, takeLeading } from "redux-saga/effects";
import handleNetworkError from "sagas/helpers/handleNetworkError";
import { post } from "sagas/helpers/network";

function* execute(action: sage.actions.file.IDownloadFile) {
    yield put(setDownloadFileStatus(action.fileId, "loading"));
    try {
        const response = yield post("/get-file", {
            file_id: action.fileId,
            populate_download_link: true,
        });
        if (response.data !== null) {
            const file = response.data as sage.model.IFile;
            if (file.download_url) {
                const link = document.createElement("a");
                link.download = file.friendly_name || "unnamed.blend";
                link.href = file.download_url;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            yield put(setDownloadFileStatus(action.fileId, "none"));
        } else {
            yield put(setDownloadFileStatus(action.fileId, "error"));
        }
    } catch (e) {
        yield handleNetworkError(e);
        yield put(setDownloadFileStatus(action.fileId, "error"));
    }
}

export default function* saga(): Generator {
    yield takeLeading("com.sage.actions.file.IDownloadFile", execute);
}
